import * as React from "react";
import { SVGProps } from "react";
const SvgFileImage = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#file-image_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.111 3.111H14V0H3.111A3.11 3.11 0 0 0 0 3.111V14h3.111V3.111ZM12.333 18 6 26h19l-4.75-6.4-3.214 4.336L12.333 18ZM24 10.5a2.497 2.497 0 0 0-3.457-2.31A2.496 2.496 0 0 0 19 10.5c0 1.383 1.117 2.5 2.5 2.5s2.5-1.117 2.5-2.5ZM28.889 0H18v3.111h10.889V14H32V3.111A3.11 3.11 0 0 0 28.889 0Zm0 28.889H18V32h10.889A3.11 3.11 0 0 0 32 28.889V18h-3.111v10.889ZM3.11 18H0v10.889A3.11 3.11 0 0 0 3.111 32H14v-3.111H3.111V18H3.11Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="file-image_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFileImage;
